import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import Logger from '@/lib/Logger'

class ClEntry {
  static attributeNames() {
    return ['id', 'clMasterId', 'entryText', 'orderPosition']
  }
  // -
  static getClean(dirtyObj) {
    Logger.debug('dirtyObj', dirtyObj)
    let cleanObject = {}
    this.attributeNames().forEach(attrname => {
      if (attrname in dirtyObj) {
        cleanObject[attrname] = dirtyObj[attrname]
      }
    })
    Logger.debug('cleanObject:', cleanObject)
    return cleanObject
  }

  static async create(entryNew, clMaster) {
    Logger.debug('ClEntry.create', entryNew, clMaster)
    entryNew.clMasterId = clMaster.id

    return GqlClient.runMutation({
      dataKey: 'clEntryAdd',
      mutation: gql`
        mutation($input: ClEntryInput!) {
          clEntryAdd(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: ClEntry.getClean(entryNew),
      },
    })
  }

  static save(entry) {
    Logger.debug('ClEntry.save', entry)
    return GqlClient.runMutation({
      mutation: gql`
        mutation($input: ClEntryInput!) {
          clEntryChange(input: $input) {
            clEntry {
              id
            }
          }
        }
      `,
      variables: {
        input: ClEntry.getClean(entry),
      },
    })
  }

  static delete(id) {
    Logger.debug('ClEntry::delete', id)
    return GqlClient.runMutation({
      mutation: gql`
        mutation($id: ID!) {
          clEntryDelete(clEntryId: $id) {
            info
          }
        }
      `,
      variables: {
        id: id,
      },
    })
  }
}

export default ClEntry
